import { color, Common } from '@stockbit/ui';
import { showFileName } from 'global/StreamWidget/utils';
import { ExtensionBadge, FileItem, IconCloseFile } from './styled';

const { Flex, Iconmoon, Text } = Common;

interface FileContainerProps {
  documents?: Array<any>;
  onSetDocuments: (file: any) => any;
}

function FileContainer({ documents, onSetDocuments }: FileContainerProps) {
  const handleRemoveFile = (file) => {
    const docIndex = documents.findIndex((doc) => doc === file);
    const documentFiles = [...documents];
    documentFiles.splice(docIndex, 1);
    // remove file here
    onSetDocuments(documentFiles);
  };

  const getDocumentType = (document) => {
    const filename = document.name || showFileName(document);
    const parsedFilename = filename.length > 33 ? filename.substr(0, 20) + '...' + filename.substr(filename.length - 6, 6) : filename
    const extension = parsedFilename.split('.').pop()

    switch (extension) {
      case 'pdf':
        return 'PDF'

      case 'xls':
      case 'xlsx':
        return 'XLS'

      case 'doc':
      case 'docx':
        return 'DOC'

      default:
        return 'PPT'
    }
  }

  if (documents.length === 0) {
    return <div />;
  }

  return (
    <>
      {documents.map((doc) => {
        const extension = getDocumentType(doc);
        const humanFilename = doc.name || showFileName(doc);
        const parsedFileName = humanFilename.length > 33 ? humanFilename.substr(0, 20) + '...' + humanFilename.substr(humanFilename.length - 6, 6) : humanFilename

        return (
          <FileItem>
            <Flex>
              <ExtensionBadge extension={extension}>
                <Text color={color.light} family="bold" weight="700" size="9px" height="16px" pt="1px">
                  {extension}
                </Text>
              </ExtensionBadge>
              <Text as="a" color={color.primary} ellipsis>
                {parsedFileName}
              </Text>
            </Flex>
            <IconCloseFile
              className="icon-compose_close"
              onClick={() => handleRemoveFile(doc)}
            />
          </FileItem>
        )
      })}
    </>
  );
}

export default FileContainer;
